<template>
  <div>
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap> 
              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Client Name *"
                v-model="formSchema.client_name" 
                :rules="[v => !!v || 'Client name is required !',lng100]"
                required	
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Sector Name *"
                  item-text="name_with_sn"
                  item-value="id"
                  v-model="formSchema.sector_id"
                  :items="SectorIdList" 
                  :rules="[v => !!v || 'Sector name is required !']"
                  required
                  @input="changeSecotr(formSchema.sector_id)"
                  ></v-autocomplete>              
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                label="Sub Sector Name"
                item-text="sub_sector_name"
                item-value="id"
                v-model="formSchema.sub_sector_id"
                :items="SubSectorIdList"                 
                required>
              </v-autocomplete>          
              <!-- :rules="[v => !!v || 'Sub sector name is required !']" -->     
            </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Phone No"
                v-model="formSchema.phone" 
                :rules="[phoneNum]"
                ></v-text-field>
              </v-flex>  

              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Office Address"
                v-model="formSchema.office_address"   
                ></v-text-field>
              </v-flex>  

              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Fax"
                v-model="formSchema.fax" 	
                :rules="[faxNum, lng30]"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Email ID"
                v-model="formSchema.email" 
                :rules="[email]"  	
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Contact Person"
                v-model="formSchema.contact_person" 	
                :rules="[lng100]"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                label="Contact Phone"
                v-model="formSchema.contact_person_phone" 	
                :rules="[rules.phoneNumber]"
                ></v-text-field>
              </v-flex>

              

              <v-flex xs12 sm6 md6>
                <v-textarea
                solo
                name="input-7-4"
                label="Remarks"
                v-model="formSchema.remarks"  
                >               
                ></v-textarea>
              </v-flex>							

              <v-flex xs12 sm6 md4>
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="isActiveVal"></v-checkbox>
              </v-flex>
                            
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="reset">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../../services/common.service"); 

export default {
  props: ["formSchema"], 
  
  data: () => ({
    valid: true,
    isActiveVal: 1, 
    SectorIdList:[],
    SubSectorIdList:[],  
    rules: {
      phoneNumber: (v) => {
        // const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$/;
        // return pattern.test(value) || "Enter valid phone no.";
        if (v && v.length > 0) {
          return (
            /(\+)?^[+0-9\(\)_.-]*$/.test(v) ||
            "Phone no. must be valid"
          );
        } else {
          return true;
        }
      },
    },

  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
      ? "Edit Client Information"
      : "Add Client Information";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },
  
  created() {    
    commonService.getAllData("client-for-drodown-data").then(res => {
      
       res.SectorList.forEach((item, full,index) => {
         item.name_with_sn = item.short_name ? item.sector_name +' ('+item.short_name+')' : item.sector_name
      })
      this.SectorIdList = res.SectorList;
    });
  },

  methods: { 
    
    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      var formSchema = this.formSchema;   
      formSchema.type = 'client';

      if (formSchema.id > 0) {
        commonService
        .updateFormData(formSchema, "client-information")
        .then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: "edit",
            status: res.status
          };
          this.close(actionData);
        });
      } else {
        commonService
        .insertFormData(formSchema, "client-information")
        .then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: "add",
            status: res.status
          };
          this.close(actionData);
        });
      }
    },

    changeSecotr(sector_id)
    {
      if(sector_id>0){
        commonService.getAllDataById(sector_id, "get-subsector-list").then(res =>{        
          this.SubSectorIdList = res.data;
        });      
      }
    },

    close: function(data) {
      if(data.status==1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }                      
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/lending/clientsupplier/clientInfo/insertForm.vue